/** @todo FC-739 Удалить этот файл с экспортами в следующей мажорной версии */
import { getLayoutContextValue } from './src/getLayoutContextValue';

/** @deprecated */
export const determineLayoutContext = getLayoutContextValue;
export { determineLayout as determineDeviceByClientSize } from './src/deprecated/determineLayout';

export * from './src/deprecated/constants';
